var exports = {
  "uF": "PermissionComponents.module__stateButtonsContainer___ejhuek",
  "ev": "PermissionComponents.module__stateButton___ejhuek",
  "uz": "PermissionComponents.module__stateButtonDisabled___ejhuek",
  "Jj": "PermissionComponents.module__stateButtonEnabled___ejhuek",
  "c$": "PermissionComponents.module__stateButtonDeny___ejhuek",
  "D5": "PermissionComponents.module__stateButtonNeutral___ejhuek",
  "N$": "PermissionComponents.module__stateButtonAllow___ejhuek",
  "Z9": "PermissionComponents.module__stateButtonInactive___ejhuek",
  "Ds": "PermissionComponents.module__stateDivider___ejhuek",
  "oq": "PermissionComponents.module__overwriteToggle___ejhuek",
  "rt": "PermissionComponents.module__overwriteToggleDense___ejhuek",
  "HC": "PermissionComponents.module__overwriteToggleContent___ejhuek",
  "_O": "PermissionComponents.module__overwriteToggleTitle___ejhuek",
  "Jw": "PermissionComponents.module__overwriteToggleTitleEnabled___ejhuek",
  "Mr": "PermissionComponents.module__overwriteToggleTitleDisabled___ejhuek",
  "GE": "PermissionComponents.module__overwriteToggleDescription___ejhuek",
  "fD": "PermissionComponents.module__overwriteToggleActions___ejhuek",
  "Wk": "PermissionComponents.module__categoryContainer___ejhuek",
  "yj": "PermissionComponents.module__categoryDivider___ejhuek",
  "p8": "PermissionComponents.module__categoryTitle___ejhuek",
  "LW": "PermissionComponents.module__categoryPermissions___ejhuek",
  "wk": "PermissionComponents.module__categoryPermissionsDense___ejhuek",
  "n2": "PermissionComponents.module__categoryPermissionsGrid___ejhuek",
  "HF": "PermissionComponents.module__roleToggle___ejhuek",
  "_y": "PermissionComponents.module__roleToggleDense___ejhuek",
  "vx": "PermissionComponents.module__tooltipTriggerBlock___ejhuek",
  "RO": "PermissionComponents.module__tooltipTriggerInline___ejhuek",
  "Iz": "PermissionComponents.module__roleCategoryContainer___ejhuek",
  "mj": "PermissionComponents.module__roleCategoryDivider___ejhuek",
  "rh": "PermissionComponents.module__roleCategoryTitle___ejhuek",
  "XC": "PermissionComponents.module__roleCategoryPermissions___ejhuek",
  "MC": "PermissionComponents.module__roleCategoryPermissionsDense___ejhuek",
  "bE": "PermissionComponents.module__roleCategoryPermissionsGrid___ejhuek",
};

module.exports = exports;
